import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Tooltip } from '@swyftx/aviary/atoms/Tooltip/Tooltip';
import { ShopItemVariant } from '@swyftx/features/shop/api/types';

import { cn } from '@shared/utils/lib/ui';

type Props = {
  id: string;
  variants: ShopItemVariant[];
  selectedVariant: number;
  setSelectedVariant: (selectedVariant: number) => void;
};

const ShopItemVariantPicker: React.FC<Props> = ({ id, variants, selectedVariant, setSelectedVariant }) => (
  <FlexLayout direction='row' alignItems='center' justifyContent='center' className='pb-24' spacing={4}>
    {variants.map((variant, index) => (
      <Tooltip key={variant.name} title={variant.name}>
        <FlexLayout
          data-testid={`${id}_variant_picker_${index}`}
          alignItems='center'
          justifyContent='center'
          className={cn(
            'h-28 w-28 rounded-[100%] border-color-border-main p-4',
            selectedVariant === index
              ? 'border border-color-border-accent'
              : 'hover:border hover:border-color-border-hover',
          )}
          onClick={() => setSelectedVariant(index)}
        >
          <div className='h-full w-full cursor-pointer rounded-[100%]' style={{ background: variant.color }} />
        </FlexLayout>
      </Tooltip>
    ))}
  </FlexLayout>
);

export { ShopItemVariantPicker };
